module.exports = __webpack_public_path__ + "img/room-design-competition_ar.2845ebd7.png";